// hooks
import { useHistory, useLocation } from 'react-router-dom'
import { useToken } from 'App'
import { Client } from 'api'
// components
import ClientMarker from './ClientMarker'
import { clientMarkerColors } from './constants'

interface Props {
  clients: Client[] | undefined
  onClick: (latlng: L.LatLng) => void
}
const ClientsLayer = ({ clients, onClick }: Props) => {
  const { push } = useHistory()
  const { pathname } = useLocation()

  const { userRole } = useToken()

  return (
    <>
      {clients?.map((client, index) => (
        <ClientMarker
          position={[client.latitude, client.longitude]}
          eventHandlers={{
            click: ({ latlng }) => {
              onClick(latlng)
              if (userRole !== 'regular' && !/measurement/i.test(pathname))
                push(`/user/${client.userId}/stats`)
            },
          }}
          color={clientMarkerColors[client.fixQuality]}
          key={client.userId + index}
        />
      ))}
    </>
  )
}

export default ClientsLayer
